<template>
   <div class="page" >
     <div class="infos">
       支付成功！
     </div>

     <div class="btn" @click="retrunFn()">去往首页</div>
    
   </div>
</template>
<script>
import Vue from 'vue'
import config from '@/config/index'

export default {
  data () {
    return {
      token : ''
    }
  },
  created () {
  },
  mounted () {
    const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js' ;//在线引用

      document.head.appendChild(s);

    let mchData ={action:'onIframeReady',displayStyle:'SHOW_CUSTOM_PAGE'}
    let postData = JSON.stringify(mchData)
    parent.postMessage(postData,'https://payapp.weixin.qq.com')
  },
  methods: {
    retrunFn(){
      let mchData = {
        action: 'jumpOut',
        jumpOutUrl: config.baseUrl
      };
      let postData = JSON.stringify(mchData);
      parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    },
    getInfos(name){
      let querys = window.location.search.substring(1);
      let admins = querys.split("&");
      for (let i = 0; i < admins .length; i++) {
        let hasddf = admins [i].split("=");
        if (hasddf [0] == name) {
            return hasddf [1];
        }
      }
      return null;
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    }

  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  padding: 16px;
  box-sizing: border-box;

  font-size: 16px;
  
}
.infos{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  font-size: 16px;

}

.btn{
  width: 200px;
  height: 50px;
  border: 1px solid #FE630C;
  color: #FE630C;
  border-radius: 25px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

</style>
